/* global axios */
import ApiClient from '../ApiClient';

// A journey being sold to one customer.
//
// `get` is always asked for a contact, never a conversation. A trip belongs to the
// customer and outlives the conversation it started in - see
// docs/travelport/trip-and-conversation-design.md - so "does this person have a trip" is
// the only question the panel can usefully ask.
class TravelTrips extends ApiClient {
  constructor() {
    super('travel/trips', { accountScoped: true });
  }

  // `conversationId` narrows to one thread's trips for the conversation sidebar, and is
  // omitted by the contact page, which wants the customer's whole history.
  get({ contactId, conversationId }) {
    return axios.get(this.url, {
      params: { contact_id: contactId, conversation_id: conversationId },
    });
  }

  create(trip) {
    return axios.post(this.url, { trip });
  }

  update(id, trip) {
    return axios.patch(`${this.url}/${id}`, { trip });
  }

  refresh(id) {
    return axios.post(`${this.url}/${id}/refresh`);
  }

  // The digest is the snapshot the agent actually read. The server refuses with 409 if the
  // booking moved again in the meantime, so the alarm is never cleared for a change nobody
  // has seen.
  acknowledgeScheduleChange(id, digest) {
    return axios.post(`${this.url}/${id}/acknowledge_schedule_change`, {
      digest,
    });
  }
}

export default new TravelTrips();
